var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tiptap',{ref:"editorRef",attrs:{"lang":"ko","extensions":_vm.extensions,"height":_vm.height,"charCounterCount":false},on:{"onUpdate":_vm.handleUpdateEditor},model:{value:(_vm.editorValue),callback:function ($$v) {_vm.editorValue=$$v},expression:"editorValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }